import React from 'react';

import './Home.css';

const Home = ({ content }) => {
  if (content.length) {
    const { image, titre, sous_titre: sousTitre } = content[0].acf;
    return (
      <div
        className="page-container"
        id="accueil"
        style={{ backgroundImage: `url(${image.url})` }}
      >
        <h1>
          {titre}
          <br />
          <span>{sousTitre}</span>
        </h1>
      </div>
    );
  }
  return null;
};

export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home/Home.js